import React, { useState } from "react";
import "./Subscription.css";
import Babies from "./Babies";
import FeedBack from "./FeedBack";
import Current_Plan from "./Current_Plan";
import Subscri_History from "./Subscri_History";

const Subscription = ({userId}) => {
  const [propertyTab, setPropertyTab] = useState("current_plan");
  return (
    <div>
      <div className="wrapper_cstm_tabers">
        <ul>

          <li
            className={propertyTab === "current_plan" ? "active" : ""}
            onClick={() => setPropertyTab("current_plan")}
          >
            Current Plan
          </li>

          <li
            className={propertyTab === "subscription_history" ? "active" : ""}
            onClick={() => setPropertyTab("subscription_history")}
          >
            Subscription History
          </li>

        </ul>
      </div>

      {propertyTab === "current_plan" && <Current_Plan userId={userId} />}
      {propertyTab === "subscription_history" && <Subscri_History userId={userId} />}
    </div>
  );
};

export default Subscription;
